export const languageData = {
  en: { value: 'en', label: 'English' },
  fr: { value: 'fr', label: 'French' },
  ar: { value: 'ar', label: 'Arabic' }
}
